import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { addState, updateState } from "../../../slices/state";
import { useEffect } from "react";
import { fetchAllCountry } from "../../../slices/country";


const validationSchema = Yup.object().shape({
    country_name: Yup.string()
        .required("Country is required"),
    name: Yup.string()
        .min(3, "State Name must be at least 3 characters")
        .max(50, "State Name must not exceed 50 characters")
        .matches(/^[a-zA-Z]+([a-zA-Z\s]*[a-zA-Z]+)?$/, "State Name can only contain letters")
        .required("State Name is required"),
    state_code: Yup.string()
        .min(3, "State Code must be at least 3 characters")
        .max(20, "State Code must not exceed 20 characters")
        .matches(/^[a-zA-Z]+$/, "State Code can only contain letters")
        .required("State Code is required"),
});
const AddStateForm = ({ editData = null,onSuccess }) => {
    const dispatch = useDispatch()
    const { allCountries, isLoading } = useSelector((state) => state.bmrState);
    const initialValues = {
         country_name: editData?.country_id
            ? String(editData.country_id)
            : editData?.country_details?.id
                ? String(editData.country_details.id)
                : editData?.country?.id
                    ? String(editData.country.id)
                    : "",
        name: editData?.name ?? "",
        state_code: editData?.state_code ?? "",
    };
    useEffect(() => {
        dispatch(fetchAllCountry());
    }, []);

    const countryOptions = Array.isArray(allCountries)
        ? allCountries.map((c) => ({
            label: c.name,
            value: String(c.id),
        }))
        : [];

    const handleSubmit = async (values) => {
    const payload = {
        name: values.name,
        state_code: values.state_code,
        country_id: values.country_name, 
    };

    if (editData) {
        await dispatch(updateState({ data: payload, editId: editData.id }));
    } else {
        await dispatch(addState(payload));
    }
    if (onSuccess) onSuccess(); 
};
    const handleStateCodeChange = (e) => {
        formik.setFieldValue("state_code", e.target.value.toUpperCase());
    };
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true
    })


    const formOptions = [
        {
            label: 'Country',
            type: 'select',
            name: 'country_name',
            required: true,
            placeholder: "Select Country",
            options: countryOptions
        },
        {
            label: 'State Name',
            type: 'text',
            name: 'name',
            required: true,
            placeholder: "Enter State Name",
        },
        {
            label: 'State Code',
            type: 'text',
            name: 'state_code',
            required: true,
            placeholder: 'Enter State Code ',
            onChange: handleStateCodeChange 
        },

    ];

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                            <FormikControl formik={formik} {...props} />
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton
                            loading={isLoading}
                            fullWidth type="submit" variant="contained">{editData ? "Update" : "Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default AddStateForm;
